import { Footer, FooterAlt, FooterLite, Header, FooterVariant } from '@aspendental/shared-components-web';
import { IBanner } from '@aspendental/shared-components-web/lib/components/Banner/Banner';
import { IGoogleMap } from '@aspendental/shared-components-web/lib/components/GoogleMap/GoogleMap';
import { ReactNode } from 'react';
import { AdFooter, App, Maybe, NavigationLink, Page } from '@src/lib/__generated/sdk';
interface LayoutPropsInterface {
  children: ReactNode;
  appData: Maybe<App>;
  footerData: Maybe<AdFooter>;
  isFooterLite?: boolean;
  isFooterAlt?: boolean;
  withSimpleLayout?: boolean;
  locale: string;
  preview: boolean;
  showHeaderNavMenu: boolean;
  breadcrumbsData: Page;
  locationNavigationLinks?: Array<NavigationLink | Page> | undefined;
  withFixedHeader: boolean;
  disableStickyFooterOnMobile: boolean | null;
  disableStickyFooterOnDesktop: boolean | null;
  disableHeaderTopAlertBanner: boolean | null;
  disableHeaderBottomAlertBanner: boolean | null;
  hideLocation?: boolean;
  hidePrimaryActionButton?: boolean;
}
function getFooter(footerData: Maybe<AdFooter>, isFooterLite: boolean, isFooterAlt: boolean, withSimpleLayout: boolean, breadcrumbsData: Page | undefined, disableStickyFooterOnMobile: boolean | null, disableStickyFooterOnDesktop: boolean | null) {
  if (isFooterLite) {
    return <FooterLite disclaimer={footerData?.disclaimer as any} footerData={footerData as any} breadcrumbsData={breadcrumbsData as any} />;
  }
  if (isFooterAlt) {
    return <FooterAlt footerData={footerData as any} />;
  }
  if (footerData?.variant === 'teamTag') {
    return <FooterVariant footerData={footerData as any} withScheduling={withSimpleLayout} breadcrumbsData={breadcrumbsData as any} isLightFooter={!!footerData?.isLightFooter} />;
  }
  return <Footer footerData={footerData as any} withScheduling={withSimpleLayout} breadcrumbsData={breadcrumbsData as any} isLightFooter={!!footerData?.isLightFooter} disableStickyFooterOnMobile={disableStickyFooterOnMobile} disableStickyFooterOnDesktop={disableStickyFooterOnDesktop} data-sentry-element="Footer" data-sentry-component="getFooter" data-sentry-source-file="layout.tsx" />;
}
export const Layout = ({
  appData,
  footerData,
  isFooterLite = true,
  isFooterAlt = false,
  withSimpleLayout = false,
  children,
  showHeaderNavMenu,
  breadcrumbsData,
  locationNavigationLinks,
  withFixedHeader,
  disableStickyFooterOnMobile,
  disableStickyFooterOnDesktop,
  hideLocation = false,
  hidePrimaryActionButton = false,
  disableHeaderTopAlertBanner,
  disableHeaderBottomAlertBanner
}: LayoutPropsInterface) => {
  return <>
			{appData && <Header locationNavigationLinks={locationNavigationLinks as any} appData={appData as any} withOfficeDetails showHeaderNavMenu={showHeaderNavMenu} phoneNumber={appData?.header?.phoneNumber ?? null} withFixedHeader={withFixedHeader} useHeaderLocationCards={appData?.header?.useHeaderLocationCards} hideLocation={hideLocation} hidePrimaryActionButton={hidePrimaryActionButton} googleMapsForLocationCards={appData?.header?.googleMapsForLocationCards as IGoogleMap} topAlertBanner={appData?.header?.topAlertBanner as IBanner} bottomAlertBanner={appData?.header?.bottomAlertBanner as IBanner} disableHeaderTopAlertBanner={disableHeaderTopAlertBanner} disableHeaderBottomAlertBanner={disableHeaderBottomAlertBanner} />}
			{children}
			{footerData && getFooter(footerData, isFooterLite, isFooterAlt, withSimpleLayout, breadcrumbsData, disableStickyFooterOnMobile, disableStickyFooterOnDesktop)}
		</>;
};